<template>
  <div class="index-carousel-wrap">
    <TitleCard :titles="titles"
               :showMore="false"
               isSwitch
               :defaultSelected="defaultId">
      <div class="index-carousel-item-wrap">
        <Carousel @picChange="toPicDetail"
                  :picture="analysisList.list"
                  v-if="analysisList.list && analysisList.list.length"></Carousel>
        <div class="noDataImg"
             v-else>
          <img src="../../../../public/static/noImg.png"
               alt="" />
        </div>
        <Collapse :options="analysisList.list"
                  @toDetail="toDetaila"
                  @toMore="toMore"
                  v-if="analysisList.list && analysisList.list.length"></Collapse>
        <div class="noData"
             v-else>
          <img src="../../../../public/static/nodata.png"
               alt="" />
        </div>
      </div>
    </TitleCard>
  </div>
</template>

<script>
import Carousel from '@/components/common/Carousel.vue'
import Collapse from '@/components/common/Collapse.vue'
import { mapGetters } from 'vuex'

export default {
  props: {
    analysisList: Object,
    titles: Array,
    defaultId: Number || String
  },
  data() {
    return {
    }
  },
  components: {
    Carousel,
    Collapse
  },
  computed: {
    ...mapGetters('headerMenu', ['setUpdateMenuList']),
    menuList() {
      return this.setUpdateMenuList
    }
  },
  methods: {
    // 处理手风琴item项的跳转逻辑
    toDetaila(item) {
      this.$emit('handleDetail', item)
    },
    // 处理点击轮播图的跳转逻辑
    toPicDetail(item) {
      this.$emit('handleDetail', item)
    },
    // 点击更多跳转跳转到列表页
    toMore() {
      this.$router.push({
        path: '/informationService',
        query: {
          code: 'xinxiServer',
          selectedId: this.commonHandle('xinxiServer', 'analysisReport')
        }
      })
    },
    commonHandle(codeOne, codeTwo) {
      let obj = this.menuList.filter((res) => res.code === codeOne)
      let selectedId
      obj[0].children.forEach((res) => {
        if (res.code === codeTwo) {
          selectedId = res.id
        }
      })
      return selectedId
    }
  }
}
</script>

<style></style>
